import {
  DueDisplayOptions,
  PlannedOccurrence,
  Task,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { addDays, startOfDay } from 'date-fns';

import { getEarliestUncompletedOccurrence } from './get-earliest-uncompleted-occurrence';
import { getNextOccurrence } from './get-next-occurrence';
import { getActiveSchedule } from './schedules/get-active-schedule';
import { getNextScheduleTimeframe } from './schedules/get-schedule-timeframe-by-date';

export type GetFutureOccurrenceOptions = {
  plannedOccurrence?: PlannedOccurrence;
  displayDue: DueDisplayOptions[];
  today: Timestamp;
  displayDate?: Timestamp;
  weekStartsOn: WeekDays;
};

export const getFutureOccurrence = (
  task: Task,
  {
    plannedOccurrence,
    displayDue,
    today,
    displayDate,
    weekStartsOn,
  }: GetFutureOccurrenceOptions,
) => {
  if (plannedOccurrence || !displayDue.includes(DueDisplayOptions.Future)) {
    return undefined;
  }

  const activeSchedule = getActiveSchedule(task.schedules, today);
  if (!activeSchedule) {
    return undefined;
  }

  const dateToMeasureFrom = displayDate ?? today;
  // from tomorrow: an endDate can clamp nextTimeframe onto the current one
  const searchStart = startOfDay(addDays(dateToMeasureFrom, 1));
  const nextTimeframe = getNextScheduleTimeframe(
    activeSchedule,
    dateToMeasureFrom,
    weekStartsOn,
  );

  const occurrence = getEarliestUncompletedOccurrence(task, {
    startDate: searchStart,
    endDate: nextTimeframe.endDate,
    today,
    weekStartsOn,
  });

  if (occurrence) {
    return occurrence;
  }

  // a replacement schedule that starts after the active one ends is invisible to its timeframes
  return getNextOccurrence(task, { today, weekStartsOn, from: searchStart });
};
